import { CdepApi } from '@appfolio/backstage-plugin-cdep-common';
import { DeploymentsApi } from '@appfolio/backstage-plugin-deployments-common';
import { createApiRef } from '@backstage/core-plugin-api';

export const deploymentsApiRef = createApiRef<DeploymentsApi>({
  id: 'plugin.deployments.service',
});

export const cdepApiRef = createApiRef<CdepApi>({
  id: 'plugin.cdep.service',
});
